<template>
  <v-container fluid class="py-6">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <v-card class="mb-6" elevation="2">
          <v-card-title class="primary white--text">
            <v-icon color="white" class="mr-2">mdi-clipboard-list</v-icon>
            Avaliação da Administração
          </v-card-title>
          <v-card-text class="pa-4">
            <v-select
              v-model="questaoSelecionada"
              :items="questoueshabilitadas"
              item-text="descricao"
              item-value="id"
              return-object
              label="Selecione a questão"
              outlined
              dense
              hide-details
            >
              <template v-slot:item="{ item }">
                <v-list-item-icon>
                  <v-icon :color="statusCor(item.id)">{{ statusIcone(item.id) }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ item.descricao }}</v-list-item-title>
                  <v-list-item-subtitle>{{ respondidasTexto(item.id) }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-select>
          </v-card-text>
        </v-card>

        <v-card v-if="questaoSelecionada" elevation="2">
          <v-card-text class="pa-4">
            <div class="d-flex align-center mb-4">
              <p class="body-1 font-weight-medium mb-0 flex-grow-1">{{ questaoSelecionada.descricao }}</p>
              <v-chip :color="statusCor(questaoSelecionada.id)" outlined small>
                <v-icon left small>{{ statusIcone(questaoSelecionada.id) }}</v-icon>
                {{ respondidasTexto(questaoSelecionada.id) }}
              </v-chip>
            </div>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Instituição</th>
                    <th style="width: 260px">Resposta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="inst in listaInstituicao" :key="inst.pkescola">
                    <td>{{ inst.descricao }}</td>
                    <td>
                      <v-select
                        v-model="respostas[inst.pkescola]"
                        :items="opcao"
                        item-text="descricao"
                        item-value="id"
                        placeholder="Selecione"
                        dense
                        hide-details
                        class="py-2"
                      ></v-select>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn
              :disabled="!todasRespondidas"
              :color="todasRespondidas ? 'success' : 'grey'"
              :loading="salvando"
              @click="salvar"
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-else-if="!carregando" class="text-center pa-8" elevation="1">
          <p class="text--secondary mb-0">Nenhuma questão habilitada para este processo.</p>
        </v-card>

        <v-card v-if="carregando" class="text-center pa-8" elevation="1">
          <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000">{{ snackbarText }}</v-snackbar>
  </v-container>
</template>

<script>
import filtros from "@/libs/filters";
import AvaliacaoInstitucionalServices from "@/services/avaliacaoInstitucional/AvaliacaoInstitucionalServices";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AvaliacaoAdministrativa",
  data: () => ({
    listaInstituicao: [],
    questoueshabilitadas: [],
    opcao: [],
    listarespondida: [],
    questaoSelecionada: null,
    respostas: {},
    carregando: false,
    salvando: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "success",
  }),
  components: {},
  filters: filtros,
  computed: {
    ...mapGetters({ param: "avaliacao/param" }),
    todasRespondidas() {
      return this.listaInstituicao.length > 0 && this.listaInstituicao.every((inst) => !!this.respostas[inst.pkescola]);
    },
    totalInstituicoes() {
      return this.listaInstituicao.length;
    },
    mapaRespondidas() {
      const mapa = {};
      this.listarespondida.forEach((r) => {
        mapa[r.id_questao] = r.instituicoes;
      });
      return mapa;
    },
  },
  watch: {
    questaoSelecionada() {
      this.resetRespostas();
    },
  },
  methods: {
    ...mapActions({ requestQuestao: "avaliacao/requestQuestao", requestResponder: "avaliacao/requestResponder" }),
    resetRespostas() {
      const respostas = {};
      this.listaInstituicao.forEach((inst) => {
        respostas[inst.pkescola] = null;
      });
      this.respostas = respostas;
    },
    async loadinstituicao() {
      const { id_processo } = this.param.Selecionado;
      const data = await AvaliacaoInstitucionalServices.instituicaoHabilitadaProcesso(id_processo);
      this.listaInstituicao = data;
      this.resetRespostas();
    },
    async loadQuestoes() {
      const { id, questoes } = this.param.Selecionado;

      let d = await this.requestQuestao({ id_questionario: id });

      let data = d.data;
      const questionario = data[0];
      this.opcao = data[1];
      this.opcao.map((i) => {
        i.descricao = `${i.descricao} (valor: ${i.valor})`;
      });
      this.questoueshabilitadas = questionario.filter((i) => {
        i.descricao = `${i.ordem}) ${i.descricao}`;
        return questoes.includes(i.ordem);
      });
    },
    async salvar() {
      this.salvando = true;
      try {
        const payload = this.listaInstituicao.map((inst) => ({
          id_instituicao: inst.pkescola,
          id_questionario: this.param.Selecionado.id,
          id_questao: this.questaoSelecionada.id,
          id_resposta: this.respostas[inst.pkescola],
        }));
        const paramsSalvar = {
          dados: payload,
          cabecalho: { id_questionario: this.param.Selecionado.id, id_questao: this.questaoSelecionada.id },
        };
        const data = await AvaliacaoInstitucionalServices.responderAdministrativo(paramsSalvar);
        await this.loadRespondidas();
        this.exibirMensagem(data?.success || "Respostas salvas com sucesso!", "success");
        this.questaoSelecionada = null;
      } catch (e) {
        this.exibirMensagem("Erro ao salvar respostas. Tente novamente.", "error");
      } finally {
        this.salvando = false;
      }
    },
    async loadRespondidas() {
      try {
        const { id } = this.param.Selecionado;
        const data = await AvaliacaoInstitucionalServices.administrativosRespondidas(id);
        this.listarespondida = data;
      } catch (error) {
        console.error(error);
      }
    },
    exibirMensagem(texto, cor) {
      this.snackbarText = texto;
      this.snackbarColor = cor;
      this.snackbar = true;
    },
    respondidasCount(idQuestao) {
      return this.mapaRespondidas[idQuestao] || 0;
    },
    respondidasTexto(idQuestao) {
      return `${this.respondidasCount(idQuestao)} de ${this.totalInstituicoes} instituições responderam`;
    },
    statusIcone(idQuestao) {
      const count = this.respondidasCount(idQuestao);
      if (count === 0) return "mdi-circle-outline";
      if (this.totalInstituicoes > 0 && count >= this.totalInstituicoes) return "mdi-check-circle";
      return "mdi-progress-clock";
    },
    statusCor(idQuestao) {
      const count = this.respondidasCount(idQuestao);
      if (count === 0) return "grey";
      if (this.totalInstituicoes > 0 && count >= this.totalInstituicoes) return "success";
      return "warning";
    },
  },
  mounted: async function () {
    this.carregando = true;
    await Promise.all([this.loadinstituicao(), this.loadQuestoes(), this.loadRespondidas()]);
    this.carregando = false;
  },
};
</script>
